// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { useState } from 'react';
import { OpenAiWidget } from '../components/OpenAiWidget';
import { Sidebar } from '../components/Sidebar';
import { AssessmentHeader } from '../components/AssessmentHeader';
import { AssessmentInitiation } from '../components/AssessmentInitiation';
import * as styles from '../styles/OpenAiView.styles';

export interface OpenAiViewProps {
  userName?: string;
  userEmail?: string;
  onLogout?: () => void;
}

export const OpenAiView = ({ userName, userEmail, onLogout }: OpenAiViewProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const [functionalArea, setFunctionalArea] = useState('AI');
  const [expertiseLevel, setExpertiseLevel] = useState(''); // No default; user must select
  const [dimensionToBeAssessed, setDimensionToBeAssessed] = useState('');

  const displayName = userName || 'Alex Thompson';
  const userInitial = userEmail ? userEmail.charAt(0).toUpperCase() : displayName ? displayName.charAt(0) : 'A';

  return (
    <div style={styles.pageWrapperStyle}>
      <Sidebar userInitial={userInitial} onLogout={onLogout} />
      <div style={styles.mainColumnStyle}>
        <AssessmentHeader userName={displayName} onLogout={onLogout} />
        <main style={styles.mainContentStyle}>
          {!isOpen && (
            <AssessmentInitiation
              onStartAssessment={() => setIsOpen(true)}
              functionalArea={functionalArea}
              setFunctionalArea={setFunctionalArea}
              expertiseLevel={expertiseLevel}
              setExpertiseLevel={setExpertiseLevel}
              dimensionToBeAssessed={dimensionToBeAssessed}
              setDimensionToBeAssessed={setDimensionToBeAssessed}
              userEmail={userEmail}
              userName={userName}
            />
          )}
          {isOpen && (
            <div style={styles.aiContainerStyle}>
              <OpenAiWidget
                setIsOpenCallback={setIsOpen}
                role={functionalArea}
                level={expertiseLevel}
                dimensionToBeAssessed={dimensionToBeAssessed}
                userEmail={userEmail}
                userName={userName}
              />
            </div>
          )}
        </main>
      </div>
    </div>
  );
};
